export const isBrowser = typeof window !== "undefined";
//# sourceMappingURL=is-browser.js.map